


















import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import PdMonitorAdequacy from "../pdMonitorAdequacy/index.vue";
import PdMonitorBalance from "../pdMonitorBalance/index.vue";
import PdMonitorNutri from "../pdMonitorNutri/index.vue";
import PdMonitorPsychology from "../pdMonitorPsychology/index.vue";
import PdMonitorSf from "../pdMonitorSf/index.vue";

@Component({
  components: {
    PdMonitorAdequacy,
    PdMonitorBalance,
    PdMonitorNutri,
    PdMonitorPsychology,
    PdMonitorSf
  }
})
export default class PdMonitorMain extends AbpBase {
  @Prop() patient: any;
  currentTab: string = "tabPdMonitorAdequacy";
  tabs: any = [
    {
      label: "充分性评估",
      name: "tabPdMonitorAdequacy",
      component: PdMonitorAdequacy
    },
    {
      label: "腹膜平衡试验",
      name: "tabPdMonitorBalance",
      component: PdMonitorBalance
    },
    {
      label: "营养评估",
      name: "tabPdMonitorNutri",
      component: PdMonitorNutri
    },
    {
      label: "心理健康评估",
      name: "tabPdMonitorPsychology",
      component: PdMonitorPsychology
    },
    {
      label: "生活质量评估",
      name: "tabPdMonitorSf",
      component: PdMonitorSf
    }
  ];

  //点击tab时才显示页面
  handleClickTab(tabName: string) {
    this.currentTab = tabName;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/parts/pdMonitorMain/index.vue